/**
 * @internal Intended for internal use - use it on your own risk
 */
export var DEFAULT_NOTIFICATIONS = {};